import React from "react";
import { useRouteLoaderData } from "react-router-dom";
import {
  contactUpdate,
  contactUpdateLongDescription,
} from "../../../../../api/contact";
import ContactForm from "./ContactForm";

const contactUpdateAction = async ({ request }) => {
  const formData = await request.formData();
  const contactEntityId = formData.get("contactEntityId");

  const submission = {
    contactEntityId,
    request: formData.get("request"),
    status: formData.get("status"),
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    email: formData.get("email"),
    phone: formData.get("phone"),
  };

  const res = await contactUpdate({ ...submission });

  if (res.code === "SUCCESS") {
    const oldLongDescription = formData.get("oldLongDescription");
    const newLongDescription = formData.get("longDescription");
    if (encodeURIComponent(newLongDescription) !== oldLongDescription) {
      await contactUpdateLongDescription(contactEntityId, newLongDescription);
    }
  }
  return res;
};

const ContactUpdateForm = () => {
  const { contact, longDescription } = useRouteLoaderData("adminContact");

  return <ContactForm
    contact={contact}
    longDescription={longDescription}
  />;
};

export { contactUpdateAction };
export default ContactUpdateForm;